// extracted by mini-css-extract-plugin
module.exports = {"MainDivSB":"ModalTandC_MainDivSB__Gtxrg"};